import React from 'react';

import { AtlassianLogo } from '@atlaskit/logo';

const LogoLarge = (): React.JSX.Element => {
	return <AtlassianLogo size="large" appearance="brand" />;
};

export default LogoLarge;
